import { FanModel } from './../../../models/fan/fan.model';

export class MessageModel {
   message: string;
   accountType: string;
   fanList: Array<FanModel>;
   selectedFan?: FanModel;
   ctnList?: Array<number>;

   constructor() {
     this.message = '';
     this.accountType = '';
     this.fanList = new Array<FanModel>();
   }
}

